import styled from 'styled-components'

const TimeLine = styled.section`
display: flex;
justify-content: center;
flex-direction: column;
color: black;
line-height: 22px;

#Experience {
  padding: 50px;
  min-height: 600px;
  width: 100%;
  z-index: 2;
}

`

export default TimeLine